<template>
  <div>
    <a-drawer width="960" placement="right" :title="dataSource.title" :visible="visible" @close="onClose">
      <div v-if="Object.keys(dataSource).length !== 0">
        <a-descriptions title="详情" :column="2">
          <a-descriptions-item v-if="dataSource.creator" label="创建人">{{ dataSource.creator.nickname }}</a-descriptions-item>
          <a-descriptions-item label="创建时间"> {{ dataSource.created_time }} </a-descriptions-item>
          <a-descriptions-item label="类型"> <a-badge v-if="dataSource.status" :color="storyTypes[dataSource.requirement_type].color" :text="storyTypes[dataSource.requirement_type].label" /> </a-descriptions-item>
          <a-descriptions-item label="更新时间"> {{ dataSource.updated_time }} </a-descriptions-item>
          <a-descriptions-item label="优先级">{{ dataSource.priority }}</a-descriptions-item>
          <a-descriptions-item label="开始时间"> {{ dataSource.start_time }} </a-descriptions-item>
          <a-descriptions-item label="状态"> <a-badge v-if="dataSource.status" :status="storyStatus[dataSource.status].status" :text="storyStatus[dataSource.status].label" /> </a-descriptions-item>
          <a-descriptions-item label="结束时间"> {{ dataSource.end_time }} </a-descriptions-item>
          <a-descriptions-item v-if="dataSource.version" label="所属迭代"> {{ dataSource.version.name || null }} </a-descriptions-item>
          <a-descriptions-item label="备注信息"> {{ dataSource.comment }} </a-descriptions-item>
        </a-descriptions>
        <a-divider />
        <a-descriptions title="描述">
          <div class="ql-container ql-snow">
            <div class="ql-editor">
              <div v-html="dataSource.description">{{ dataSource.description }}}</div>
            </div>
          </div>
        </a-descriptions>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import { storyStatus, storyTypes, storyPrioritys } from '@/utils/dictionary';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    dataSource: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      storyStatus,
      storyTypes,
      storyPrioritys
    };
  },
  methods: {
    onClose() {
      this.$emit('close', 'cancel');
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.ql-editor {
  padding: 0;
}
</style>
